<template>
  <div>
    <van-nav-bar
        title="发票"
        left-arrow
        class="my-nav"
        :fixed="true"
        @click-left="$router.back(-1)"
    />

    <div class="body">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-search
            class="search-warp"
            v-model="value"
            show-action
            placeholder="请输入单据名称"
            @search="onSearch"
        >
          <template #action>
            <div @click="onSearch">搜索</div>
          </template>
        </van-search>
        <div class="title-warp">
          <div class="title">xxx</div>
          <div class="sub-title">xxxxx</div>
        </div>
        <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
        >
          <van-cell v-for="item in list" :key="item" :title="item" value="xxx" label="开票时间：2020.04.25"/>
        </van-list>
      </van-pull-refresh>
    </div>

    <div class="footer">
      <van-button color="#1989fa" block style="margin-bottom: 10px" @click="show=true">确认</van-button>
      <van-button block>申请复核</van-button>
    </div>
    <van-popup v-model="show" round position="bottom" :style="{ height: '36%' }" class="popup">
      <div>
        您确认 <br>2020年5月 <br> 发票无误？
      </div>
      <div class="btns">
        <van-button color="#1989fa">是</van-button>
        <van-button>否</van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>

export default {
  data() {
    return {
      value: 1,
      active: 2,
      data: [
        {
          title: 'xxx'
        }
      ],
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      show: false
    };
  },
  mounted() {
  },
  methods: {
    onSearch() {
    },
    onLoad() {
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      setTimeout(() => {
        for (let i = 0; i < 10; i++) {
          this.list.push(this.list.length + 1);
        }

        // 加载状态结束
        this.loading = false;

        // 数据全部加载完成
        if (this.list.length >= 40) {
          this.finished = true;
        }
      }, 1000);
    },
    onRefresh() {
      this.list = []
      // 清空列表数据
      this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
      this.refreshing = false
    },
  }
};
</script>

<style lang="less" scoped>
.body {
  padding: 45px 0 120px;
}

.title-warp {
  margin: 15px;
}

.title {
  text-align: center;
  line-height: 2em;
}
.sub-title {
  font-weight: bold;
}

.search-warp {
  //background: #eee;
  border-bottom: 1px solid #eee;
}

.van-cell {
  color: #333;
}

.footer {
  background: #fff;
  padding: 15px;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
}

.btns {
  position: absolute;
  left: 20px;
  right: 20px;
  bottom: 20px;
  display: flex;
  justify-content: space-between;

  > * {
    min-width: 100px;
  }
}

.popup {
  box-sizing: border-box;
  padding: 20px;
}
</style>
